import { ScrollView, StyleSheet, Text, View } from "react-native";
import React, { useState } from "react";
import CreateWalletScreen from "./CreateWalletScreen";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import Colours from "../../utils/Colours";
import CreateWalletScreenBuyMeeza from "./CreateWalletScreenBuyMeeza";
import { useRoute } from "@react-navigation/native";
import { SafeAreaView } from "react-native-safe-area-context";
import { useNavigation } from "expo-router";

const WalletScreen = ({
  hideModal,
  setHasDva,
  //isVerified,
  setIsVerified,
}) => {
  const [showCustomerVerificationScreen, setShowCustomerVerificationScreen] = useState(false);
  const [showVerifiedCustomer, setShowVerifiedCustomer] = useState(false);
  const route = useRoute();
  const { isVerified, isEmailVerified } = route.params;
  const navigation = useNavigation();
  return (
    <SafeAreaView>
      {/* <TopHeaderComponent headerText={'Create Wallet'} hideScreen={hideModal} /> */}
      <TopHeaderComponent headerText={"Buy Meeza Credit"} hideScreen={() => navigation.goBack()} />

      <ScrollView
        style={styles.componentStyle}
        contentContainerStyle={{ flexGrow: 1, paddingBottom: 100 }}
        showsVerticalScrollIndicator={false}
      >
        {/* <CreateWalletScreen
                    showCustomerVerificationScreen={showCustomerVerificationScreen}
                    setShowCustomerVerificationScreen={setShowCustomerVerificationScreen}
                    showVerifiedCustomer={showVerifiedCustomer}
                    setShowVerifiedCustomer={setShowVerifiedCustomer}
                    hideWalletScreen={hideModal}
                    setHasDva={setHasDva}
                /> */}
        <CreateWalletScreenBuyMeeza
          //   setIsVerified={setIsVerified}
          isVerified={isVerified}
          isEmailVerified={isEmailVerified}
          //   showCustomerVerificationScreen={showCustomerVerificationScreen}
          //   setShowCustomerVerificationScreen={setShowCustomerVerificationScreen}
          //   showVerifiedCustomer={showVerifiedCustomer}
          //   setShowVerifiedCustomer={setShowVerifiedCustomer}
          //   hideWalletScreen={hideModal}
          //   setHasDva={setHasDva}
        />
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  componentStyle: {
    backgroundColor: Colours.LIGHTEST,
    height: "100%",
  },
});

export default WalletScreen;
